<template>
    <div>
        <router-view/>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
    data() {
        return {
            isSmgr : false
        }
    },
    created() {
        this.initTransForm();
    },
    methods : {
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        initTransForm() {
            let Authorization = localStorage.getItem("Authorization");
            if (Authorization !== null && Authorization !== undefined) {
                let obj = this;
                let reqData = {
                    url : "/api/org/checkSmgr",
                    method : "post"
                };
                obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then(function(res) {
                    if(res.errorCode != null) {
                        console.log(res.errorCode)
                    } else {
                        obj.$router.replace("/general/home");
                    }
                })
                .catch(function(err) {
                    console.log(err);
                });
            } else {
                this.$router.replace("/login")
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/Index.vue